import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-signing-page js-main-content" }
const _hoisted_2 = { class: "gfu-1of1 gfu-6of12--m gfu-6of12--xl gfu-signing-page__intro" }
const _hoisted_3 = { class: "gfu-signing-page__benefits" }
const _hoisted_4 = { class: "_fw-b _tc--dark" }
const _hoisted_5 = { class: "gfu-1of1 gfu-5of12--m gfu-4of12--xl" }
const _hoisted_6 = { class: "gfu-content-head _mt-0" }
const _hoisted_7 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_account_benefit_list = _resolveComponent("account-benefit-list")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.Account.LoginToPlatformBenefitsListHeader), 1 /* TEXT */),
        _createVNode(_component_account_benefit_list)
      ]),
      _createVNode(_component_themed_image, {
        src: "/content/images/static/signing/signing-image.svg",
        class: "gfu-signing-page__image",
        alt: _ctx.Resources.Account.LoginViewImageAltText
      }, null, 8 /* PROPS */, ["alt"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.Resources.Account.LogInHeader), 1 /* TEXT */)
      ]),
      _createVNode(_component_external_login_actions, {
        "return-url": $props.returnUrl,
        class: "_mb-3"
      }, null, 8 /* PROPS */, ["return-url"]),
      _createVNode(_component_login_form, {
        class: "gfu-box gfu-box--thick",
        "return-url": $props.returnUrl,
        "data-qa": "login-form"
      }, null, 8 /* PROPS */, ["return-url"])
    ])
  ]))
}